
import Printd from 'printd'

const ReportsMixin = (getFunction) => {
  return {
    data(){
      return{
        searched: false,
        title: 'za sezonu',
        period: {
          to: new Date(),
          from: new Date(),
        },
        type: 'offline',

        subscriptionTitleFallbacks: {
          0:  "Premijerna pretplata",
          1:  "Dramska pretplata",
          2:  "Operna pretplata",
          3:  "Baletna pretplata",
          4:  "Vikend pretplata",
          5:  "Vikend pretplata",
          6:  "Europska pretplata",
          7:  "Popularna pretplata",
          8:  "Popularna pretplata",
          9:  "Popularna pretplata",
          10: "Operno - baletna pretplata",
          11: "Moja prva pretplata",
          12: "Kazalište za obitelj 1",
          13: "Pretplata K - HNK",
          14: "Kazalište za obitelj 2",
          15: "Adventski koncert",
          16: "Adventski koncert",
          20: "Pretplate 5 I 6",
          21: "Razgled kazališta",
          22: "Razgled kazališta"
        }
      }
    },

    methods: {
      getByDate(){
        if(this.period.from !== null && this.period.to !== null && this.period.from <= this.period.to){
          let filter = {
            type: this.type,
            to: this.period.to.toLocaleDateString('hr-HR'),
            from: this.period.from.toLocaleDateString('hr-HR'),
          }
          this.$store.dispatch(getFunction, filter);

          this.title = `za razdoblje od ${this.period.from.toLocaleDateString('hr-HR')}
          do ${this.period.to.toLocaleDateString('hr-HR')}`
        }

        this.searched = true;
      },

      /*getSubscriptionTitle(subscriptionID){
        return this.$store.state.receivedData.subscriptions.list.filter((subscription) => {
          return subscription.subscription_number == subscriptionID
        })[0].title_hr
      },*/

      // Hot Fix 2025-09-01
      getSubscriptionTitle(subscriptionID) {
        var key = String(subscriptionID);

        var list =
          (this.$store &&
          this.$store.state &&
          this.$store.state.receivedData &&
          this.$store.state.receivedData.subscriptions &&
          this.$store.state.receivedData.subscriptions.list)
            ? this.$store.state.receivedData.subscriptions.list
            : [];

        var match = list.find(function (sub) {
          return String(sub.subscription_number) === key;
        });

        if (match) {
          return match.title_hr
              || match.title
              || this.subscriptionTitleFallbacks[key]
              || "Nepoznato";
        }

        return this.subscriptionTitleFallbacks[key] || "Nepoznato";
      },

      
      

      print(component){
        let p = new Printd();
        p.print(component,
        [`
        .print-btn{
          display: none;
        }

        .capitalize{
          text-transform: capitalize;
        }

        .t-align-right{
          text-align: right !important;
        }

        .t-align-left{
          text-align: left !important;
        }

        .subscription-type{
          font-weight: bold;
        }

        .reports-payment td{
          border-top: 1px solid black;
        }

        .reports-payment tr:last-of-type td{
          border-bottom: 1px solid black;
        }

        h2{
          font-size: 18px;
          font-family: 'Calibri';
          text-align: center;
        }

        h2 span{
          display: block;
        }

        .lighter{
          font-size: 16px;
          font-weight: lighter;
        }

        .cash-register-play{
          page-break-after: always;
        }

        .general-table:first-of-type{
          margin-bottom: 0;
        }

        .general-table:first-of-type + .md-table{
          margin-top: 20px;
        }

        .general-table td:first-of-type{
          width: 15%;
          max-width: 15%;
          min-width: 15%;
        }

        .general-table td:not(:first-of-type){
          width: 7%;
          min-width: 7%;
          max-width: 7%;
        }

        .general-table th:first-of-type{
          width: 15%;
          max-width: 15%;
          min-width: 15%;
        }
        .general-table th:not(:first-of-type){
          width: 7%;
          min-width: 7%;
          max-width: 7%;
        }

        h3{
          margin: 35px 0 20px;
          font-size: 20px;
          font-family: 'Calibri';
        }

        .last-row{
          font-weight: bold;
        }

        .print-table + .print-table{
          margin-top: 40px;
        }

        .small-table{
          max-width: 400px;
          margin-top: 40px;
        }

        .print-table table, .print-table{
          font-family: 'Calibri';
          width: 100%;
          table-layout: fixed;
          border-spacing: 0;
        }

        .print-table.not-fixed table, .print-table.not-fixed{
          table-layout: initial;
        }

        .print-table td:not(:first-of-type), .print-table th:not(:first-of-type){
          text-align: right;
        }

        .print-table td, .print-table th{
          font-size: 10px;
        }

        .print-table th:first-of-type{
          text-align: left;
        }

        .last-row td{
          border-top: 0.25pt solid black;
        }

        .reports-cash{
          border-spacing: 0;
          table-layout: fixed;
          font-family: 'Calibri';
          margin-top: 50px;
        }

        .reports-cash svg{
          display: none;
        }

        .reports-cash td{
          box-sizing: border-box;
          padding: 5px;
          border: 0;
          vertical-align: top;
          font-size: 14px;
          text-align: left !important;
          border-top: 0.25pt solid black;
        }

        .reports-cash th{
          box-sizing: border-box;
          vertical-align: top;
          text-align: left !important;
          padding: 5px;
          font-size: 14px;
        }
        `]
        )
      }
    }
  }
}

export default ReportsMixin;


// WEBPACK FOOTER //
// ./src/mixins/reports-mixin.js